<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="ecs-agent-load-allowance white--text" @click="menuOpen = !menuOpen">
    <label v-once>{{ $t('label') }}</label>
    <v-menu v-model="menuOpen" :disabled="isOfflineModeEnabled" bottom offset-y z-index="160">
      <template v-slot:activator="{ on }">
        <v-row id="layout-row" class="agent-load-balance-dropdown" align="center" no-gutters v-on="on">
          <span id="txt-current-load-allowance" ref="text" :class="{ highlight: !isCurrentLoadAllowanceDefault }">
            {{ currentLoadAllowance.name }}
          </span>
          <v-spacer />
          <v-icon id="icon-dropdown" ref="dropdownIcon" dark>mdi-menu-down</v-icon>
        </v-row>
      </template>
      <v-list v-if="availableLoadAllowances.length">
        <v-list-item v-for="item in availableLoadAllowances" :key="item.id" @click="updateLoadAllowance(item)">
          <v-list-item-content>{{ item.name }}</v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list v-else class="text-center">
        <v-progress-circular :width="2" :size="20" color="primary" indeterminate />
        <span v-once>{{ $t('loading') }}</span>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'EcsAgentLoadAllowance',

  data() {
    return {
      menuOpen: false
    };
  },

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    ...mapGetters('SETTINGS', ['isOfflineModeEnabled']),

    availableLoadAllowances() {
      return this.loggedInAgent.availableLoadAllowances;
    },

    isCurrentLoadAllowanceDefault() {
      return this.loggedInAgent.loadAllowanceName === this.loggedInAgent.defaultLoadAllowance;
    },

    currentLoadAllowance() {
      const { loadAllowanceId: id, loadAllowanceName: name } = this.loggedInAgent;
      return { id, name };
    }
  },

  watch: {
    menuOpen(isOpen) {
      if (isOpen) {
        this.$refs.dropdownIcon.$el.classList.add('mdi-rotate-180');
      } else {
        this.$refs.dropdownIcon.$el.classList.remove('mdi-rotate-180');
      }
    },

    'loggedInAgent.loadAllowanceName'(value) {
      // Notify the user the Load Allowance has changed
      if (!this.isCurrentLoadAllowanceDefault) {
        this.$root.$emit('snackbar-message', {
          message: this.$t('warnings.notDefault', { loadAllowance: value }),
          type: 'warning',
          timeout: 0
        });
      }
    }
  },

  methods: {
    ...mapActions('AGENT', ['updateLoggedInAgentLoadAllowance']),

    updateLoadAllowance(loadAllowance) {
      const { id: loadAllowanceId, name: loadAllowanceName } = loadAllowance;
      this.updateLoggedInAgentLoadAllowance({ loadAllowanceId, loadAllowanceName }).catch(() => {
        this.$root.$emit('snackbar-message', {
          message: this.$t('errors.updateLoadAllowance'),
          type: 'error'
        });
      });
    }
  }
};
</script>

<style>
.ecs-agent-load-allowance .v-icon.v-icon {
  transition: color 0.2s ease-in-out;
  color: transparent;
}

.ecs-agent-load-allowance:hover .v-icon.v-icon {
  color: #fffa;
}
</style>

<style scoped>
.ecs-agent-load-allowance {
  display: flex;
  flex-direction: column;

  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  position: relative;

  height: 52px;
}

.ecs-agent-load-allowance:hover {
  background-color: #0004;
}

label {
  height: 20px;
  font-size: 12px;
  padding-top: 4px;
  user-select: none;
  opacity: 0.5;
}

#layout-row {
  min-width: 152px;
}

span {
  text-align: left;
  padding-right: 8px;
}

.highlight {
  color: var(--v-warning-base);
  font-weight: bold;
}
.agent-load-balance-dropdown {
  cursor: pointer;
}
</style>
